import './styles.css';

import React from 'react';
import classname from '@search/classname/src';
import { useTooltip } from '@vtblife/uikit';

const cn = classname.bind(null, 'MinimalBanksMortgageEconomy');

// eslint-disable-next-line max-len
const defaultTitle = 'В\u00A0связи с\u00A0возможностью выбора наиболее выгодного предложения среди представленных банков';

export function MinimalBanksMortgageEconomy({
    value,
    title = defaultTitle,
    underline = false,
    dotted,
}: {
    underline?: boolean;
    dotted?: boolean;
    title?: string;
    value: string;
}) {
    const { to, registerControl } = useTooltip();

    return (
        <span className={cn('percent')}>
            {value}
        </span>
    );
}
